import { render, staticRenderFns } from "./EventSummary.vue?vue&type=template&id=0cfdfe7e&scoped=true&"
import script from "./EventSummary.vue?vue&type=script&lang=js&"
export * from "./EventSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfdfe7e",
  null
  
)

export default component.exports